<template>
  <div class="add-phone-dlg modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("Phones.AddPhoneDlg.Title") }}</p>
      <button
          type="button"
          class="delete"
          @click="close()"/>
    </header>
    <section class="modal-card-body">
      <div class="form-group">
        <b-radio v-model="addPhoneMode" class="add-phone-mode" name="addPhoneMode" :key="+AddPhoneMode.Organic" :native-value="+AddPhoneMode.Organic">
          {{ $t("Phones.AddPhoneDlg.Mode.Organic") }}
        </b-radio>
        <b-radio v-model="addPhoneMode" class="add-phone-mode" name="addPhoneMode" :key="+AddPhoneMode.Campaign" :native-value="+AddPhoneMode.Campaign">
          {{ $t("Phones.AddPhoneDlg.Mode.Campaign") }}
        </b-radio>
      </div>
      <div class="form-group dropdown-w full-width-field" v-show="phonesPageData && !phonesPageData.CompanyId">
        <label class="caption">{{ $t('Leads.CompanyPlaceholder') }}</label>
        <b-tooltip position="is-bottom" multilined type="is-dark">
          <b-dropdown v-model="selectedCompany" scrollable :max-height="300" aria-role="list" :disabled="!companies.length"
                @active-change="onDropdownActiveChange">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ selectedCompany?.Title || $t("Leads.CompanyPlaceholder") }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="companiesSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="company in companiesFiltered" :key="company.Id" :value="company" aria-role="listitem">
              <span>{{ company.Title }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <template v-slot:content>
            <p>{{ $t("Phones.Tooltips.Filters.Company") }}</p>
          </template>
        </b-tooltip>
      </div>

      <div v-if="addPhoneMode === AddPhoneMode.Campaign && selectedCompanyId">
        <div class="form-group">
          <label class="caption">{{ $t('CampaignEdit.Type.Caption') }}</label>
          <div class="radiogroup">
            <b-radio v-model="selectedMetadataType" name="selectedMetadataType" v-for="channelMetadataType in channelMetadataTypesFiltered"
                :key="+channelMetadataType.Id" :native-value="+channelMetadataType.Id">
              {{ channelMetadataType.Title }}
            </b-radio>
          </div>
        </div>
        <div class="form-group" v-if="isMediaChannel()">
          <b-field :label="$t('CampaignEdit.CampaignTitle')">
            <b-input v-model="campaignTitle" :placeholder="$t('CampaignEdit.CampaignTitlePlaceholder')"></b-input>
          </b-field>
        </div>
        <div class="form-group dropdown-w full-width-field" v-if="!isMediaChannel()">
          <label class="caption">{{ $t('Leads.ChannelPlaceholder') }}</label>
          <b-tooltip position="is-bottom" multilined type="is-dark">
            <b-dropdown v-model="selectedChannel" scrollable :max-height="300" aria-role="list" :disabled="!channels.length"
                  @active-change="onDropdownActiveChange">
              <template #trigger>
                  <b-button>
                    <span class="dropdown-trigger-value">{{ selectedChannel?.Title || $t("Leads.ChannelPlaceholder") }}</span>
                    <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                  </b-button>
              </template>
              <b-dropdown-item custom aria-role="listitem" class="filter-search">
                <b-input v-model="channelsSearch" class="search" :placeholder="$t('Search')" expanded />
              </b-dropdown-item>
              <b-dropdown-item v-for="channel in channelsFiltered" :key="channel.Id" :value="channel"
                    aria-role="listitem" class="dropdown-item-with-icon">
                <span class="icon-w" v-if="getChannelMetadataTypeIconName(channel.ChannelType)">
                  <img :src="require('@/assets/' + getChannelMetadataTypeIconName(channel.ChannelType) + '.png')" />
                </span>
                <span class="text">{{ channel.Title }}</span>
              </b-dropdown-item>
            </b-dropdown>
            <template v-slot:content>
              <p>{{ $t("Leads.Tooltips.Filters.Channel") }}</p>
            </template>
          </b-tooltip>
        </div>
      </div>

      <div v-if="addPhoneMode === AddPhoneMode.Organic">
        <div class="dropdown-w" v-if="selectedCompanyId && campaignEditAssetsData">
          <label>{{ $t('CampaignEdit.ProjectTypeId') }}</label>
          <b-tooltip :position="labelTooltipPosition" type="is-dark" class="label-tooltip">
            <span>
              <icon-base width="16" height="16" view-box="0 0 16 16" icon-name="chart-pie"><icon-question-circle /></icon-base>
            </span>
            <template #content>
              <p>{{ $t("CampaignEdit.ProjectTypeTooltip") }}</p>
            </template>
          </b-tooltip>
          <b-dropdown v-model="selectedProjectType" scrollable aria-role="list" :expanded="true"
                @active-change="onDropdownActiveChange" @change="onSelectedProjectTypeChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ selectedProjectTypeListItem ? selectedProjectTypeListItem.Text : $t("CampaignEdit.Assets.CampaignTypePlaceholder") }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item v-for="projectType in campaignEditAssetsData.ProjectTypes" :key="+projectType.Value" :value="+projectType.Value"
                  aria-role="listitem" class="dropdown-item-with-icon">
              <span class="text">{{ projectType.Text }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="dropdown-w" v-if="showAssetsSelectList">
          <label>{{ $t('CampaignEdit.Asset') }}</label>
          <b-dropdown v-model="selectedAssetId" scrollable aria-role="list" :expanded="true"
                @active-change="onDropdownActiveChange" @change="onSelectedAssetChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ selectedClientAsset ? selectedClientAsset.title : $t("CampaignEdit.AssetPlaceholder") }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="clientAssetsSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="clientAsset in clientAssetsFiltered" :key="clientAsset.id" :value="clientAsset.id"
                  aria-role="listitem" class="dropdown-item-with-icon">
              <span class="text">{{ clientAsset.title }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="dropdown-w" v-if="showPropertiesSelectList">
          <label>{{ $t('CampaignEdit.Properties') }}</label>
          <b-dropdown v-model="selectedPropertyId" scrollable aria-role="list" :expanded="true"
                @active-change="onDropdownActiveChange" @change="onSelectedAssetChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">
                  {{ selectedClientProperty ? (selectedClientProperty.Url || selectedClientProperty.Title) : $t("CampaignEdit.PropertyPlaceholder") }}
                </span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="clientPropertiesSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="clientProperty in clientPropertiesFiltered" :key="clientProperty.Id" :value="clientProperty.Id"
                  aria-role="listitem" class="dropdown-item-with-icon">
              <span class="text">{{ clientProperty.Url ? `${clientProperty.Title} - ${clientProperty.Url}` : clientProperty.Title }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <b-button
        :label="$t('Ok')"
        type="is-primary"
        :disabled="
          (addPhoneMode === AddPhoneMode.Organic &&
            (selectedProjectType === ProjectType.None || (!selectedAssetId && !selectedPropertyId))) ||
          (addPhoneMode === AddPhoneMode.Campaign && !selectedCompanyId)
        "
        @click="save()"
      />
      <b-button :label="$t('Cancel')" @click="close()" />
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { campaignEditRoute } from "@/router";
import { ClientProject } from "@/models/ClientProject";
import { ChannelMultiselectItem, MultiselectItem, SelectListItem } from "@/models/MultiselectItem";
import { Result } from "@/models/Result";
import { ClientAsset } from "@/models/assets/ClientAsset";
import { AssetExternal } from "@/models/assets/AssetExternal";
import { AssetType } from "@/models/assets/AssetType";
import { SitePage } from "@/models/assets/SitePage";
import { CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { CampaignEditAssetsData } from "@/models/campaigns/CampaignAsset";
import { AvailableChannelMetadataTypesMode, ChannelType, ChannelMetadataTypesForMediaCampaigns } from "@/models/campaigns/ChannelType";
import { PhonesPageData } from "@/models/phones/PhonesPageData";
import CampaignService from "@/services/CampaignService";
import ConfigService from "@/services/ConfigService";
import HelperService from "@/services/HelperService";
import { CommonMultiselectPayload } from "@/services/api/ApiService";
import CampaignsApiService, { GetCampaignEditViewModelPayload } from "@/services/api/CampaignsApiService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import IconQuestionCircle from "../icons/IconQuestionCircle.vue";

const namespace = "phonesModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
    IconQuestionCircle,
  },
})
export default class AddPhoneDlg extends Vue {

  //#region Vuex getters and actions

  @Getter("assets", { namespace: "leadsModule" }) assets!: ClientProject[];
  @Getter("channels", { namespace }) channels!: ChannelMultiselectItem[];
  @Getter("companies", { namespace }) companies!: MultiselectItem[];
  @Getter("phonesPageData", { namespace }) phonesPageData!: PhonesPageData;
  @Action("getAssets", { namespace: "leadsModule" }) getAssets!: (payload: CommonMultiselectPayload) => Promise<ClientProject[]>;
  @Action("getCampaignEditViewModel", { namespace: "campaignsModule" }) getCampaignEditViewModel!: (payload: GetCampaignEditViewModelPayload) => Promise<CampaignEditViewModel>;
  @Action("getChannels", { namespace }) getChannels!: (payload: CommonMultiselectPayload) => Promise<ChannelMultiselectItem[]>;

  //#endregion Vuex getters and actions


  //#region Properties

  addPhoneMode = AddPhoneMode.Organic;
  campaignTitle = "";
  channelsSearch = "";
  clientAssetsSearch = "";
  clientPropertiesSearch = "";
  companiesSearch = "";
  selectedAssetId = 0;
  selectedMetadataType = ChannelType.None;
  selectedProjectType = AssetType.None;
  selectedPropertyId = 0;
  campaignEditAssetsData?: CampaignEditAssetsData = {
    IsAddAssetEnabled: false,
    ProjectTypes: []
  };
  selectedChannel: ChannelMultiselectItem | null = null;
  selectedCompany: MultiselectItem | null = null;
  clientAssets: ClientAsset[] = [];
  clientProperties: AssetExternal[] = [];
  sitePages: SitePage[] = [];

  AddPhoneMode = AddPhoneMode;
  ProjectType = AssetType;

  //#endregion Properties


  //#region Watchers

  @Watch("addPhoneMode", { immediate: true })
  onAddPhoneModeChange(newAddPhoneMode: AddPhoneMode, oldAddPhoneMode: AddPhoneMode): void {
    if (newAddPhoneMode === undefined) {
      return;
    }
    if (!this.campaignEditAssetsData || this.campaignEditAssetsData.ProjectTypes.length === 0) {
      CampaignsApiService.getCampaignEditAssetsData(0).then((data: CampaignEditAssetsData) => {
        this.campaignEditAssetsData = data;
      });
    }
    if (newAddPhoneMode === AddPhoneMode.Campaign) {
      this.selectedMetadataType = ChannelType.Phone;
    }
  }

  @Watch("selectedMetadataType", { immediate: true })
  onSelectedMetadataTypeChange(newSelectedMetadataType: ChannelType, oldSelectedMetadataType: ChannelType): void {
    if (newSelectedMetadataType === undefined) {
      return;
    }
    if (!this.isMediaChannel(newSelectedMetadataType)) {
      this.getChannels(this.commonPayload);
    }
  }

  //#endregion Watchers


  //#region Getters

  get channelMetadataTypesFiltered(): MultiselectItem[] {
    let result: MultiselectItem[] = [];
    result.push(...CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Campaigns));
    result.push(...CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.MediaCampaigns));
    return result;
  }

  get channelsFiltered(): ChannelMultiselectItem[] {
    return this.channels.filter((i: ChannelMultiselectItem) => i.Title.toLowerCase().indexOf(this.channelsSearch.toLowerCase()) >= 0);
  }

  get clientAssetsFiltered(): ClientAsset[] {
    return this.clientAssets.filter((i: ClientAsset) => i.title.toLowerCase().indexOf(this.clientAssetsSearch.toLowerCase()) >= 0);
  }

  get clientPropertiesFiltered(): AssetExternal[] {
    return this.clientProperties.filter((i: AssetExternal) => i.Title.toLowerCase().indexOf(this.clientPropertiesSearch.toLowerCase()) >= 0);
  }

  get companiesFiltered(): MultiselectItem[] {
    return this.companies.filter((i: MultiselectItem) => i.Title.toLowerCase().indexOf(this.companiesSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItemsByIds(this.selectedCompany ? [+this.selectedCompany.Id] : []));
  }

  get commonPayload(): CommonMultiselectPayload {
    let companyIds: number[] = [];
    if (this.selectedCompanyId) {
      companyIds = [this.selectedCompanyId];
    }
    return {
      companyIds: companyIds,
      showNotActiveCamp: false,
      metadataIds: [this.selectedMetadataType],
      statusIds: [],
      channelIds: [],
    };
  }

  get labelTooltipPosition(): string {
    return HelperService.isRtl() ? "is-left" : "is-right";
  }

  get selectedClientAsset(): ClientAsset | undefined {
    return this.clientAssets.find((i: ClientAsset) => i.id === +this.selectedAssetId);
  }

  get selectedCompanyId(): number | undefined {
    if (this.phonesPageData?.CompanyId) {
      return this.phonesPageData.CompanyId;
    } else if (this.selectedCompany) {
      return +this.selectedCompany.Id;
    }
    return undefined;
  }

  get selectedClientProperty(): AssetExternal | undefined {
    return this.clientProperties.find((i: AssetExternal) => i.Id === +this.selectedPropertyId);
  }

  get selectedProjectTypeListItem(): SelectListItem | undefined {
    return this.campaignEditAssetsData?.ProjectTypes.find((i: SelectListItem) => +i.Value === +this.selectedProjectType);
  }

  get showAssetsSelectList(): boolean {
    return [AssetType.Custom, AssetType.Facebook, AssetType.Landing, AssetType.Site].indexOf(this.selectedProjectType) >= 0;
  }

  get showPropertiesSelectList(): boolean {
    return [AssetType.CustomLandingPage, AssetType.CustomSite, AssetType.ExternalAPI].indexOf(this.selectedProjectType) >= 0;
  }

  //#endregion Getters
  

  //#region Handlers

  close() {
    this.$emit("close");
  }

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onSelectedAssetChange(assetId: number): void {
    console.log("EMPTY METHOD onSelectedAssetChange");
  }

  onSelectedProjectTypeChange(projectType: AssetType): void {
    if (this.selectedCompanyId === undefined) {
      return;
    }
    if ([AssetType.Custom, AssetType.Facebook, AssetType.Landing, AssetType.Site].indexOf(projectType) >= 0) {
      const loader = this.$loading.show();
      CampaignsApiService.getClientAssets(this.selectedCompanyId, projectType, 0, 0)
      .then((clientAssets: ClientAsset[]) => {
        this.clientAssets = clientAssets;
        loader.hide();
      });
    } else if ([AssetType.CustomLandingPage, AssetType.CustomSite, AssetType.ExternalAPI].indexOf(projectType) >= 0) {
      const loader = this.$loading.show({
        container: this.$refs.assetsTableContainer
      });
      CampaignsApiService.getClientAutoCompleteProperties(this.selectedCompanyId, projectType, 0, 0)
      .then((clientProperties: AssetExternal[]) => {
        this.clientProperties = clientProperties;
        loader.hide();
      });
    }
  }

  save() {
    if (this.addPhoneMode === AddPhoneMode.Campaign) {
      if (this.isMediaChannel()) {
        let loader = this.$loading.show();
        this.getCampaignEditViewModel({
          createPhone: true,
          id: 0
        }).then((campaignEditViewModel: CampaignEditViewModel) => {
          campaignEditViewModel.Campaign.Active = true;
          campaignEditViewModel.Campaign.IsMediaChannel = this.isMediaChannel();
          campaignEditViewModel.Campaign.ChannelType = this.selectedMetadataType;
          campaignEditViewModel.Campaign.ChannelTypeId = +this.selectedMetadataType;
          campaignEditViewModel.Campaign.CompanyId = this.selectedCompanyId || 0;
          campaignEditViewModel.Campaign.Title = this.campaignTitle;
          CampaignsApiService.saveCampaignGeneralInfo(campaignEditViewModel.Campaign).then((result: Result) => {
            if (result.Success) {
              campaignEditViewModel.Campaign.Id = result.Data as number;
              this.$router.push(`${campaignEditRoute}?Id=${campaignEditViewModel.Campaign.Id}#phones-channel`);
              this.close();
            } else {
              HelperService.showError(result.Message);
            }
          }).finally(() => {
            loader.hide();
          });
        });
      } else {
        if (this.selectedChannel) {
          this.$router.push(`${campaignEditRoute}?Id=${this.selectedChannel.Id}#phones-channel`);
          this.close();
        }
      }
    } else if (this.addPhoneMode === AddPhoneMode.Organic) {
      this.$loading.show();
      let assetId = 0;
      if (this.selectedAssetId) {
        assetId = this.selectedAssetId;
      } else if (this.selectedPropertyId) {
        assetId = this.selectedPropertyId;
      }
      location.href = `${this.getAssetEditUrl(this.selectedProjectType)}?Id=${assetId}#phones-channel`;
    }
  }

  //#endregion Handlers


  //#region Private methods

  private getAssetEditUrl(projectType: AssetType): string {
    switch (projectType) {
      case AssetType.Custom:
      case AssetType.Landing:
        return ConfigService.editLandPageUrl;
      case AssetType.CustomLandingPage:
      case AssetType.CustomSite:
      case AssetType.ExternalAPI:
        return ConfigService.editAssetUrl;
      case AssetType.Facebook:
        return ConfigService.editExternalServiceUrl;
      case AssetType.Site:
        return ConfigService.editSiteUrl;
      default:
        return "";
    }
  }

  private getChannelMetadataTypeIconName(type: ChannelType): string {
    return CampaignService.getChannelMetadataTypeIconName(type);
  }

  private isMediaChannel(metadataType?: ChannelType): boolean {
    if (metadataType === undefined) {
      return ChannelMetadataTypesForMediaCampaigns.includes(this.selectedMetadataType);
    } else {
      return ChannelMetadataTypesForMediaCampaigns.includes(metadataType);
    }
  }

  //#endregion Private methods
}

enum AddPhoneMode {
  Organic,
  Campaign
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.add-phone-dlg.modal-card {
  width: auto;

  @media (min-width: 800px) {
    width: 800px;
  }

  .modal-card-body {
    min-height: 400px;

    .b-radio.radio:not(.button) {
      display: flex;
      margin-bottom: .5rem;
      margin-right: 2rem;
    }

    .form-group {
      margin-bottom: 1rem;

      label.caption {
        display: block;
        font-weight: 600;
        margin-bottom: .5rem;
      }

      .radiogroup {
        align-items: center;
        display: flex;
        flex-wrap: wrap;

        .b-radio.radio:not(.button) {
          margin-left: 0;
          margin-right: 0;
          width: 36%;

          @media (max-width: $bp_sm) {
            width: 50%;
          }

          @media (max-width: $bp_xs) {
            width: 100%;
          }
        }
      }
    }

    .full-width-field {
      .b-tooltip {
        width: 100%;

        .dropdown {
          width: 100%;

          .button {
            width: 100%;
          }

          .dropdown-item-with-icon {
            display: flex;

            .icon-w {
              display: flex;
              margin-inline-end: 0.5rem;
              min-width: 22px;

              img {
                max-height: 22px;
                min-width: 22px;
                width: 22px;
              }
            }
          }
        }
      }
    }

    .label-tooltip {
      margin-inline-start: 0.3rem;
    }
  }
}

html[dir="rtl"] {
  .add-phone-dlg.modal-card {
    .modal-card-body {
      .b-radio.radio:not(.button) {
        margin-left: 2rem;
        margin-right: 0;
      }
    }
  }
}
</style>
